export const environment = {
    production: true,
    apiUrl: 'https://backend.flytaerp.com'
};
